/* Cart trust: small block under every checkout button (drawer + cart page), row of three on the cart page */
(function () {
  var mini = document.getElementById('HobTrustMini');
  var row = document.getElementById('HobTrustRow');
  if (!mini) return;
  function place() {
    document.querySelectorAll('.cart__ctas').forEach(function (ctas) {
      var next = ctas.nextElementSibling;
      if (next && next.classList.contains('hob-tmini')) return;
      ctas.parentNode.insertBefore(mini.content.firstElementChild.cloneNode(true), ctas.nextSibling);
    });
    var footer = document.getElementById('main-cart-footer');
    if (row && footer && !document.querySelector('.hob-trow-wrap')) footer.parentNode.insertBefore(row.content.firstElementChild.cloneNode(true), footer.nextSibling);
  }
  place();
  var drawer = document.querySelector('cart-drawer');
  var t = 0;
  if (drawer) new MutationObserver(function () { clearTimeout(t); t = setTimeout(place, 80); }).observe(drawer, { childList: true, subtree: true });
  var footer = document.getElementById('main-cart-footer');
  if (footer) new MutationObserver(function () { clearTimeout(t); t = setTimeout(place, 80); }).observe(footer, { childList: true, subtree: true });
})();
